import React, { useEffect, useState } from 'react';
import { useConfig } from "@revenuewell/logic-config";
import { useOidc } from '@revenuewell/logic-oidc';
import { useNotification } from '@revenuewell/logic-notification';
import { NavigationService, useNavigation } from '@revenuewell/logic-navigation';
import { ProductService } from '../../services/product-service';
import { IProductContextProps, ProductContext } from './context';


export interface IProductProviderProps {
  preloadOnStart?: boolean;
}

export function ProductProvider(props: React.PropsWithChildren<IProductProviderProps>) {
  const { config } = useConfig();
  const { showError } = useNotification();
  const { getClaims, oidcService, signinRedirect } = useOidc();
  const { getLocationIdUrlParam } = useNavigation();
  const [availableProducts, setAvailableProducts] = useState<string[]>();

  useEffect(() => {
    if (props.preloadOnStart) loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      const productService = new ProductService(config, oidcService, new NavigationService());
      const claims = await getClaims();
      const products = await productService.getAvailableProducts(getLocationIdUrlParam() || claims.locationId);

      setAvailableProducts(products);
    } catch (error: any) {
      if(error.status === 401 || error.status === 403)
        signinRedirect()
        
      console.error(error)
      showError("Unable to fetch list of Products")
    }
  }

  const hasProduct = (productName: string): boolean => {
    const lowercased = availableProducts?.map(p => p.toLowerCase());
    return lowercased ? lowercased.includes(productName.toLowerCase()) : false;
  }

  const context = {
    loadProducts,
    availableProducts: availableProducts,
    hasProduct: hasProduct
  } as IProductContextProps;

  return <ProductContext.Provider value={{ ...context }}>
    {(availableProducts || !props.preloadOnStart) && props.children}
  </ProductContext.Provider>;
}